import { createContext } from 'react';

import { LicenseModalContextProps } from './LicenseModalContext.types';

export const LicenseModalContext = createContext<LicenseModalContextProps | undefined>(undefined);
